import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "./Login/Login";
import Home from "./Home/Home";
import Views from "./VIews/Views";
import Sites from "./Sites/Sites";
import Users from "./Users/Users";
import Settings from "./Settings/Settings";
import AppLayout from "../Components/AppLayout/AppLayout";
import NewView from "./VIews/New View/NewView";
import NewUser from "./Users/NewUser/NewUser";
import NewSite from "./Sites/NewSite/NewSite";
import Logout from "./Logout/Logout";
import PrivateRoute from "../utils/PrivateRoute";
import Unauthorized from "./Unauthorized/Unauthorized";
import RoleBasedRoute from "../utils/RoleBasedRoute";
import EditView from "./VIews/Edit View/EditView";
import EditUser from "./Users/Edit User/EditUser";
import EditSite from "./Sites/EditSite/EditSite";
import ViewsTable from "./VIews/ViewsTable/ViewsTable";
import Beneficiaries from "./Beneficiaries/Beneficiaries";
import NewBeneficiary from "./Beneficiaries/NewBeneficiary/NewBeneficiary";

function AppRoutes() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Navigate to={"/"} />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/logout" element={<Logout />} />
        <Route
          path="/app"
          element={
            <PrivateRoute>
              <AppLayout />
            </PrivateRoute>
          }
        >
          <Route
            index
            element={
              <RoleBasedRoute allowedRoles={["SuperAdmin"]}>
                <Home />
              </RoleBasedRoute>
            }
          />
          <Route
            path="views"
            element={
              <RoleBasedRoute
                allowedRoles={["SuperAdmin", "Admin", "Employee"]}
              >
                <Views />
              </RoleBasedRoute>
            }
          />
          <Route
            path="views/new"
            element={
              <RoleBasedRoute
                allowedRoles={["SuperAdmin", "Admin", "Employee"]}
              >
                <NewView />
              </RoleBasedRoute>
            }
          />
          <Route
            path="views/table"
            element={
              <RoleBasedRoute
                allowedRoles={["SuperAdmin", "Admin", "Employee"]}
              >
                <ViewsTable />
              </RoleBasedRoute>
            }
          />
          <Route
            path="views/edit/:id"
            element={
              <RoleBasedRoute
                allowedRoles={["SuperAdmin", "Admin", "Employee"]}
              >
                <EditView />
              </RoleBasedRoute>
            }
          />
          <Route
            path="sites"
            element={
              <RoleBasedRoute allowedRoles={["SuperAdmin", "Admin"]}>
                <Sites />
              </RoleBasedRoute>
            }
          />
          <Route
            path="sites/new"
            element={
              <RoleBasedRoute allowedRoles={["SuperAdmin", "Admin"]}>
                <NewSite />
              </RoleBasedRoute>
            }
          />
          <Route
            path="sites/edit/:id"
            element={
              <RoleBasedRoute allowedRoles={["SuperAdmin", "Admin"]}>
                <EditSite />
              </RoleBasedRoute>
            }
          />
          <Route
            path="users"
            element={
              <RoleBasedRoute allowedRoles={["SuperAdmin", "Admin"]}>
                <Users />
              </RoleBasedRoute>
            }
          />
          <Route
            path="users/new"
            element={
              <RoleBasedRoute allowedRoles={["SuperAdmin", "Admin"]}>
                <NewUser />
              </RoleBasedRoute>
            }
          />
          <Route
            path="users/edit/:id"
            element={
              <RoleBasedRoute allowedRoles={["SuperAdmin", "Admin"]}>
                <EditUser />
              </RoleBasedRoute>
            }
          />
          <Route
            path="beneficiaries"
            element={
              <RoleBasedRoute allowedRoles={["SuperAdmin"]}>
                <Beneficiaries />
              </RoleBasedRoute>
            }
          />
          <Route
            path="beneficiaries/new"
            element={
              <RoleBasedRoute allowedRoles={["SuperAdmin"]}>
                <NewBeneficiary />
              </RoleBasedRoute>
            }
          />
          <Route
            path="settings"
            element={
              <RoleBasedRoute allowedRoles={["SuperAdmin", "Admin"]}>
                <Settings />
              </RoleBasedRoute>
            }
          />
        </Route>
      </Routes>
    </div>
  );
}

export default AppRoutes;
